<template>
    <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide class="swiper-slide" v-for="(item,index) in parent" :key="index">
            <div class="img">
            	<img v-lazy="pictureUrl + item.ArtworkImage" :key="pictureUrl + item.ArtworkImage"  :preview="index" />
            </div>
            <h4>{{item.TitleCN}}</h4>
            <p>{{item.MetrialCN}}</p>
            <p>{{item.Size}}</p>
            <p>{{item.Year}} <span v-show="item.Year != ''">年</span></p>
        </swiper-slide>
         <!-- 左右箭头 --> 
        <div class="swiper-button-prev" slot="button-prev" @click="prev"></div> 
        <div class="swiper-button-next" slot="button-next" @click="next"></div> 
    </swiper>
</template>

<script type="text/ecmascript-6">
	import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'
	import 'common/css/swiper.min.css'

    export default {
		components: {
			Swiper,
			SwiperSlide
		},
		directives: {
			swiper: directive
		},
        data(){
            return {
            	pictureUrl:'static/img/',
                swiperOption:{
                	slidesPerView : this.isMobile()? 1.001 : 2.1,
					spaceBetween : this.isMobile()? 0 : 40,
				    observer:true,//修改swiper自己或子元素时，自动初始化swiper
				    observeParents:true,//修改swiper的父元素时，自动初始化swiper
                    //设置点击箭头
                    navigation: {
				      	nextEl: '.swiper-button-next',
				      	prevEl: '.swiper-button-prev',
				    }
                }
            }
        },
	    computed: {
	      swiper() {
	        return this.$refs.mySwiper.$swiper
	      }
	    },
        props: {
        	//注意：组件中的所有 props 中的数据，都是通过 父组件传递给子组件的
		   	//props 中的数据，都是只读的，无法重新赋值
		    parent: {
		      	required: true
		    }
		},
		methods: {
		    prev () {
		      this.swiper.slidePrev()
		    },
		    next () {
		      this.swiper.slideNext()
		    },
		    isMobile () {
				if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
					return true // 手机端
				} else {
					return false // alert('PC端')
				}
			}
		}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.swiper-container{
		height: 100%;
		padding: 0 50px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
	.swiper-slide .img{
		display: -webkit-flex;
		display: -moz-flex;
		display: -ms-flex;
		display: -o-flex;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 75%;
		background-color: #fff;
		margin-top: 10px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		padding: 20px;
	}
	.swiper-slide .img img{
		max-width: 100%;
		max-height: 100%;
	}
	.swiper-slide h4{
		width: 100%;
		font-size: 16px;
		font-weight: 700;
		line-height: 1.5;
		text-align: left;
		margin-top: 10px;
	}
	.swiper-slide p{
		width: 100%;
		font-size: 16px;
		font-weight: 200;
		line-height: 1.5;
		text-align: left;
	}
	.swiper-button-next, .swiper-button-prev{
		width: 34px;
		height: 64px;
    	background-size: 34px 64px;
    	margin-top: -104px;
	}
	.swiper-button-prev, .swiper-container-rtl .swiper-button-next{
		left: 0;
		background-image:url(~common/images/ArrowLeftBtn.svg);
	}
	.swiper-button-next, .swiper-container-rtl .swiper-button-prev{
		right: 0;
		background-image:url(~common/images/ArrowRightBtn.svg);
	}

	@media screen and (max-width:750px) {
		.detailArtist{
			width: 100%;
			height: 100vh;
			right: 0;
			padding-left: 0;
		}
		.swiper-slide .img{
			margin-top: 0;
			padding: .2rem;
		}
		.swiper-slide h4{
			font-size: .28rem;
			margin-top: .2rem;
		}
		.swiper-slide p{
			font-size: .28rem;
		}
	}
</style>



// WEBPACK FOOTER //
// src/base/swiper/swiper.vue